// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/pages/Campaigns/containers/DowntimeDollarsBar/DowntimeDollarsBar.css
// module id = 480
// module chunks = 0